import { routes } from "./paths";

export function redirectToHomepage(userAuthority: string) {
  let redirectURL = "";
  if (userAuthority === "NURSE") {
    redirectURL = routes.NURSE_HOMEPAGE_URL;
  } else if (userAuthority === "RODA" || userAuthority === "SUPER_ADMIN") {
    redirectURL = routes.RODA_HOMEPAGE_URL;
  }

  return redirectURL;
}
